import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      const next = loc.state?.next;
      if (next) return nav(next);
      if (u.role === "admin") return nav("/admin");
      if (u.role === "driver") return nav("/driver");
      return nav("/dashboard");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20 md:py-28">
      <h1 className="font-display text-4xl tracking-tight">Welcome back</h1>
      <p className="text-muted-foreground mt-3">Sign in to manage bookings or your driver dashboard.</p>

      <Card className="mt-10 p-8 border-border">
        <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12" data-testid="login-submit-btn">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </Card>

      <p className="text-sm text-muted-foreground mt-6 text-center">
        New customer? <Link to="/register" className="text-foreground underline underline-offset-4">Create account</Link>
      </p>
    </div>
  );
}
